module.exports = "<h3 id=\"投票\">投票</h3>\n<p>在BitShares系统中，投票是非常重要的一项特性，不仅事关网络安全，同时也能影响系统的后续开发方向。如果你愿意的话，你可以将你的投票权交由代理投票账户执行。如果你设定了代理投票账户，则手动投票将相应关闭。</p>\n";